import React, { useState } from 'react'
import Modal from './Modal'
import { userState } from '../../functions/stateList'
import ModalSubmitFormButton from '../buttons/ModalSubmitFormButton'
import { userModalSubmit } from '../../functions/UserModalSubmit'
import UserModalBody from './UserModalBody'
import CarModalSelect from '../inputs/CarModalSelect'

function UserInfoModal({ customers, setCustomer, setUserResult, setShowModal, customer_types }) {
  const [isRegistered, setIsRegistered] = useState(false)
  const [inputs, setInputs] = useState({
    ...userState,
  })

  const [error, setError] = useState({
    ...userState,
    birth_date: '',
  })
  const [isSubmit, setIsSubmit] = useState(false)

  const inputHandler = (e) => {
    setInputs({
      ...inputs,
      [e.target.name]: e.target.value,
    })
    setError({
      ...error,
      [e.target.name]: '',
    })
  }

  const handleCustomer = (e) => {
    const value = e.target.value
    const name = e.target.name

    setInputs({
      ...inputs,
      [name]: value,
    })
    setCustomer(customers.find((customer) => customer?.id === parseInt(value)))
  }

  const formHandler = async (e) => {
    e.preventDefault()
    setIsSubmit(true)
    if (inputs?.['customer_id']) {
      setShowModal(false)
      setUserResult(true)
    } else
      await userModalSubmit(
        setIsSubmit,
        inputs,
        setCustomer,
        setUserResult,
        setShowModal,
        error,
        setError
      )
  }

  return (
    <Modal>
      <form onSubmit={formHandler}>
        {/*header*/}
        <div className="p-3 md:p-5">
          <h3 className="text-xl md:text-3xl font-semibold text-center dark:text-zinc-100">
            اطلاعات فردی
          </h3>
        </div>

        <label
          htmlFor="isRegistered"
          className={'text-lg mb-6 flex items-center dark:text-slate-50'}
        >
          <input
            className={'ml-2 w-4 h-4'}
            type="checkbox"
            name={'isRegistered'}
            id={'isRegistered'}
            checked={isRegistered}
            onChange={() => setIsRegistered(!isRegistered)}
          />
          مشتری قبلا ثبت شده است
        </label>
        {/*body*/}
        {isRegistered ? (
          <div className={'my-6'}>
            <CarModalSelect
              title={'کاربر مورد نظر را انتخاب کنید'}
              isSubmit={isSubmit}
              name={'customer_id'}
              value={inputs?.['customer_id'] && inputs?.['customer_id']}
              inputHandler={handleCustomer}
              error={error}
              list={customers}
              text_key={'full_name'}
            />
          </div>
        ) : (
          <UserModalBody
            setInputs={setInputs}
            inputs={inputs}
            error={error}
            isSubmit={isSubmit}
            inputHandler={inputHandler}
            customer_types={customer_types}
          />
        )}

        {/*footer*/}
        <ModalSubmitFormButton setShowModal={setShowModal} isSubmit={isSubmit} />
      </form>
    </Modal>
  )
}

export default React.memo(UserInfoModal)
